/**
 * GA4 is sent via the browser's gtag() global
 */

type GtagFn = (...args: unknown[]) => void;

declare global {
	interface Window {
		dataLayer?: unknown[];
	}
}

let gtag: GtagFn | undefined;

export const analyticsStore = {
	logApiAccess(id: string) {
		gtag?.('event', 'system_load', {
			page_title: 'SafeSystem',
			page_location: window.location.href,
			category: 'identifier',
			id
		});
	},

	logAppLoad(app?: string) {
		if (app) gtag?.('event', 'app_load', { page_title: app, page_location: window.location.href });
	},

	logNavigation(route?: string) {
		if (route)
			gtag?.('event', 'page_view', { page_title: route, page_location: window.location.href });
	},

	logServicesLayerView(layerId: string) {
		gtag?.('event', 'services_layer_view', { category: layerId });
	},

	/** Injects gtag.js and configures the GA4 property; call before any child effect logs. */
	initializeGA(gaTrackingId: string) {
		if (gtag || !gaTrackingId) return;
		const script = document.createElement('script');
		script.async = true;
		script.src = `https://www.googletagmanager.com/gtag/js?id=${gaTrackingId}`;
		document.head.appendChild(script);
		const dataLayer = (window.dataLayer = window.dataLayer ?? []);
		gtag = function (..._args: unknown[]) {
			// gtag.js requires the live `arguments` object — commands pushed as a
			// plain rest-array are silently dropped by GA.
			// eslint-disable-next-line prefer-rest-params
			dataLayer.push(arguments);
		};
		gtag('js', new Date());
		gtag('config', gaTrackingId);
	}
};
